import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel", "copyButton", "copyStatus"]
  static values = { copy: String }

  connect() {
    this.hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)")
    this.hide()
  }

  disconnect() {
    window.clearTimeout(this.hideTimeout)
    window.clearTimeout(this.copyFeedbackTimeout)
  }

  toggle(event) {
    event.stopPropagation()
    const opening = this.panelTarget.classList.contains("hidden")

    if (!opening && this.hoverQuery.matches && event.detail > 0) return

    this.panelTarget.classList.toggle("hidden", !opening)
    this.buttonTarget.setAttribute("aria-expanded", opening.toString())
  }

  show(event) {
    if (event?.type === "mouseenter" && !this.hoverQuery.matches) return

    window.clearTimeout(this.hideTimeout)
    this.panelTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  hideOnHoverLeave() {
    if (!this.hoverQuery.matches) return

    window.clearTimeout(this.hideTimeout)
    this.hideTimeout = window.setTimeout(() => this.hide(), 120)
  }

  hideOnOutside(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

  hide() {
    this.panelTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.resetCopyFeedback()
  }

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()

    try {
      await navigator.clipboard.writeText(this.copyValue)
    } catch (_error) {
      this.copyWithFallback(this.copyValue)
    }

    this.copyButtonTarget.textContent = "Copied"
    this.copyStatusTarget.textContent = `${this.panelTarget.getAttribute("aria-label")} copied to clipboard`

    window.clearTimeout(this.copyFeedbackTimeout)
    this.copyFeedbackTimeout = window.setTimeout(() => this.resetCopyFeedback(), 1800)
  }

  copyWithFallback(value) {
    const input = document.createElement("textarea")
    input.value = value
    input.setAttribute("readonly", "")
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.appendChild(input)
    input.select()
    document.execCommand("copy")
    input.remove()
  }

  resetCopyFeedback() {
    if (this.hasCopyButtonTarget) this.copyButtonTarget.textContent = "Copy"
    if (this.hasCopyStatusTarget) this.copyStatusTarget.textContent = ""
  }
}
